import { put, call, takeLatest } from "redux-saga/effects";

import {
  TotalRevenueRequest,
  TotalRevenueSuccess,
  TotalRevenueFailure,
  TotalActiveProductsRequest,
  TotalActiveProductsSuccess,
  TotalActiveProductsFailure,
  getRecentOrdersRequest,
  getRecentOrdersSuccess,
  getRecentOrdersFailure,
  getlowStockProductsRequest,
  getlowStockProductsSuccess,
  getlowStockProductsFailure,
} from "./Dashboard-slice";
import sellerApi from "../../utils/sellerApi";

function* TotalRevenueSaga(action) {
  try {
    const response = yield sellerApi.post(`/getTotalRevenue`, {
      params: action.payload,
    });
    yield put(TotalRevenueSuccess(response.data));
  } catch (error) {
    yield put(TotalRevenueFailure(error.message));
  }
}

export function* watchTotalRevenue() {
  yield takeLatest(TotalRevenueRequest.type, TotalRevenueSaga);
}

function* TotalActiveProductsSaga(action) {
  try {
    const response = yield sellerApi.get(`/getActiveProducts`, {
      params: action.payload,
    });
    yield put(TotalActiveProductsSuccess(response.data));
  } catch (error) {
    yield put(TotalActiveProductsFailure(error.message));
  }
}

export function* watchTotalActiveProducts() {
  yield takeLatest(TotalActiveProductsRequest.type, TotalActiveProductsSaga);
}

function* getRecentOrdersSaga(action) {
  try {
    const response = yield sellerApi.get(`/getRecentOrders`, {
      params: action.payload,
    });
    yield put(getRecentOrdersSuccess(response.data));
  } catch (error) {
    yield put(getRecentOrdersFailure(error.message));
  }
}

export function* watchGetRecentOrders() {
  yield takeLatest(getRecentOrdersRequest.type, getRecentOrdersSaga);
}

function* getlowStockProductsSaga(action) {
  try {
    const response = yield sellerApi.get(`/getLowStockProducts`, {
      params: action.payload,
    });
    yield put(getlowStockProductsSuccess(response.data));
  } catch (error) {
    yield put(getlowStockProductsFailure(error.message));
  }
}

export function* watchGetlowStockProducts() {
  yield takeLatest(getlowStockProductsRequest.type, getlowStockProductsSaga);
}
